export default {
  'dashboard.OfflineData.conversionRate': 'Tiến độ',
};
